import * as yup from "yup";

import { IChangeTransferPin } from "../../interfaces-and-types";

export const createTransferPinSchema: yup.SchemaOf<IChangeTransferPin> = yup
  .object({
    current_pin: yup.string().required("Current PIN is required"),
    new_pin: yup
      .string()
      .min(4, "PIN is too short. Minimum is 4 digits")
      .required("New PIN is required"),
    confirm_pin: yup
      .string()
      .oneOf([yup.ref("new_pin"), null], "New pin and confirmation must match")
      .required("PIN confirmation is required"),
  })
  .required();
